/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_EntitiesInputs */

const en_entity_entities = /** @type {(inputs: Entity_EntitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entities`)
};

const de_entity_entities = /** @type {(inputs: Entity_EntitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitäten`)
};

/**
* | output |
* | --- |
* | "Entities" |
*
* @param {Entity_EntitiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_entities = /** @type {((inputs?: Entity_EntitiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_EntitiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entities(inputs)
	return de_entity_entities(inputs)
});